import Route from '@ember/routing/route';
import { inject as service } from '@ember/service';
import Thenby from 'thenby';

export default class TieTimingRoute extends Route 
{
	@service resultsAjax;
	@service store;
	
	model(params) 
	{
		var event = this.modelFor('event');
		var event_id = event.id;
		
		var tieGroups = [];
		var currentTieGroup = null;
		return this.resultsAjax.request("/events/"+event_id+"/results/individuals").then(function(results)
		{
			return results.map(function(result){return result.data.attributes;});
		}).then(function(results)
		{
			return results.filter(function(result){return result.isTie;});
		}).then(function(results)
		{
			return results.sort(new Thenby('classGroupId').thenBy('totalTimeInMilliseconds'));
		}).then(function(results)
		{
			var classGroupId = null;
			var totalTimeInMilliseconds = null;

			results.forEach(function(result)
			{
				if(result.ClassGroupId != classGroupId || result.totalTimeInMilliseconds != totalTimeInMilliseconds)
				{
					if(currentTieGroup != null)
						tieGroups.push(currentTieGroup);
					currentTieGroup = [];
					classGroupId = result.ClassGroupId;
					totalTimeInMilliseconds = result.totalTimeInMilliseconds;
				}
				currentTieGroup.push(result);
			});
			if(currentTieGroup != null)
				tieGroups.push(currentTieGroup);
			return {
				ties: tieGroups,
				event: event
			};
		});
	}
}
